import Services from './base-services'

const service = new Services('message')
import mapParameters from '../utils/map-parameters'

export default {
    getSentMessage(data: any) {
        const params = mapParameters({
            fromUserId: data && data.id ? data.id : null,
            pageNumber: data && data.init ? data.init : null,
            pageSize: data && data.finish ? data.finish : null,
        })
        return service.post(`getSentMessage`, params)
    },
    getReceivedMessage(data: any) {
        return service.get(
            `getReceivedMessage?toUserId=${data.id}&pageNumber=${data.init}&pageSize=${data.finish}`
        )
    },
    deleteMessage(messageId: number) {
        return service.delete(`deleteMessage?messageId=${messageId}`, { messageId })
    },
    getInboxMessages(
        userId: number,
        pageNumber: string | number = 0,
        pageSize: number | string = 20
    ) {
        return service.get(
            `getInboxMessages?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
        )
    },
    setReadMessages(data: any) {
        return service.put(`setReadMessages`, data)
    },
}
